import { getStorageItem } from './helpers';

export const getToken = (key = 'variant-token') => getStorageItem(key);

export const checkPage = (requiredPage: string, pages: string[]) => pages.includes(requiredPage);

export const validatePages = (currentPages: string[], requiredPages: string[], matchAll = false) => {
  const fn = (page: string) => checkPage(page, currentPages);

  return matchAll ? requiredPages.every(fn) : requiredPages.some(fn);
};
